import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { map, Observable, of, switchMap } from "rxjs";
import { inject } from "@angular/core";
import { UtilsAmcoService } from "app/core/services";
import { EPermsGlobal } from "app/core/statics";

export const CombinedGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
    const utilsService = inject(UtilsAmcoService);
    const router = inject(Router);

    return utilsService.getPerms().pipe(map(perms => {
        const requestedPath = state.url.split('?')[0].split('/').filter(Boolean).shift();

        // Mappa i permessi all'enum per ottenere i percorsi accessibili
        Object.keys(EPermsGlobal).map(path => {
            path.toLowerCase().replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
        });

        // Converte le chiavi dell'enum in camelCase per confrontarle con i permessi
        const accessiblePaths: any[] = Object.keys(EPermsGlobal)
            .filter(key => perms[toCamelCase(key)] === 1) // Verifica i permessi in camelCase
            .map(key => EPermsGlobal[key as keyof typeof EPermsGlobal]); // Prende il percorso corrispondente

        // Se l'utente ha accesso al percorso richiesto, consentire l'accesso
        if (accessiblePaths.includes(requestedPath)) {
            return true;
        }

        // Trova il primo percorso disponibile e reindirizza l'utente
        const firstAvailablePath = accessiblePaths.length > 0 ? accessiblePaths[0] : null;

        if (firstAvailablePath) {
            router.navigate([`/${firstAvailablePath}`]);
        } else {
            router.navigate(['/dashboard']);
        }
        return false;
    }))
};

const toCamelCase = (str: string): string => {
    return str.toLowerCase().replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
};




